<template>
    <div class="content" :style="{height:showHeight}">
          <div class="content__icon">
            <div class="content__icon__wrapper left">
              <span
                class="iconfont content__icon__wrapper__item"
                @click="routeBack"
              >
              &#xe6a0;
              </span>
            </div>
            <div class="content__icon__wrapper left">
              <span
                class="iconfont content__icon__wrapper__item"
                @click="changeFontSizeSubtract"
              >
                &#xe629;
              </span>
            </div>
            <div class="content__icon__wrapper left">
              <span
                class="iconfont content__icon__wrapper__item"
                @click="changeFontSizeAdd"
              >
              &#xe681;
              </span>
            </div>
          </div>
          <Voice :voiceText="voiceText"/>
          <div class="content__item">
            <div class="content__img" v-if="contentText.typeName === '图片'">
              <img />
            </div>
            <div class="content__text" v-else>
              <h4 class="content__text__h4">{{contentText.primersTitle}}</h4>
              <h3 class="content__text__h3">{{contentText.title}}</h3>
              <h4 class="content__text__h4">{{contentText.subtitle}}</h4>
              <p class="content__text__p">
                <span>日期：{{contentText.pageDate}}</span>
                <span>【{{contentText.pageNum}}版：{{contentText.pageName}}】</span>
              </p>
              <p class="content__text__author">
                <span>【作者：{{contentText.author}}】</span>
              </p>
              <div
                class="content__text__img"
                v-for="(itemPictures, index) in attachedPictures"
                :key="index"
              >
                <img
                  :src="`${imgUrl}/${itemPictures.accessName}/${itemPictures.accessName}/${itemPictures.outfilePath}/${itemPictures.originalFile}`"
                />
                <p v-html="itemPictures.picExplain"></p>
              </div>
              <div class="content__text__content" ref="add" v-html="content"></div>
            </div>
          </div>
    </div>
    <!-- <Daily
      v-if="periodical == 0"
      :newspaper="newspaper"
      :newspaperId="newspaperId"
      @emit-home="getDailyPageList"
      @getContentDirectory="getContentDirectory"
    />
    <Periodical v-else :newspaper="newspaper" :newspaperId="newspaperId" @emit-content="getDailyPageList" /> -->
</template>
<script>
// import Periodical from '../components/Periodical'
// import Daily from '../components/Daily'
import Voice from '../content/Voice'
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { get } from '../../utils/request'

export default {
  name: 'Content',
  components: { Voice },
  setup (context) {
    const count = ref(0.5)
    const add = ref('')
    const swiper = ref()
    const voiceText = ref('')
    const contentText = ref([])
    const contentList = ref([])
    const typeName = ref()
    const newspaper = ref()
    const swiperIndex = ref()
    const newsId = ref()
    const newspaperId = ref('')
    const attachedPictures = ref([])
    const content = ref()
    const showHeight = ref()
    const periodical = ref()
    const attachedList = ref()
    // const contentPicList = ref([])
    const Base64 = require('js-base64').Base64
    const imgUrl = process.env.VUE_APP_UPLOAD_URL
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    newspaper.value = route.params.accessName
    newsId.value = route.params.newsid
    store.dispatch('getNewspaper', newspaper.value)
    onMounted(() => {
      window.fullHeight = document.documentElement.clientHeight
      showHeight.value = window.fullHeight + 'px'
    })
    const getContentText = async () => {
      const url = `/tableNewsController/getTableNews?id=${newsId.value}&accessName=${newspaper.value}`
      // const url = '/tableNewsController/getTableNews?id=FDF33E50D4D549C9B05F636C06690E3C&accessName=xlglrb'
      const result = await get(url)
      contentText.value = result.data
      const title = contentText.value.title
      document.title = title
      const primersTitle = contentText.value.primersTitle
      const subtitle = contentText.value.subtitle
      content.value = Base64.decode(contentText.value.content)
      voiceText.value = (title + primersTitle + subtitle + content.value).replace(/<[^>]+>/g, '')
      typeName.value = contentText.value.typeName
      attachedPictures.value = []
      result.data.attachedPictures.map((item, index) => {
        const picExplain = Base64.decode(item.picExplain)
        attachedList.value = {
          accessName: item.accessName,
          outfilePath: item.outfilePath,
          originalFile: item.originalFile,
          picExplain: picExplain
        }
        attachedPictures.value.push(attachedList.value)
      })
    }
    getContentText()
    const getNewspaper = async () => {
      const url = `/newspaperController/getNewspaper?name=${newspaper.value}`
      const result = await get(url)
      periodical.value = result.data.periodical
      newspaperId.value = result.data.id
      store.dispatch('getPeriodical', periodical.value)
    }
    getNewspaper()
    const changeFontSizeAdd = () => {
      if (count.value < 0.57) {
        count.value += 0.01
        add.value.style.fontSize = count.value + 'rem'
      }
    }
    // // 排序方法
    // const compare = (key) => {
    //   return (a, b) => {
    //     var val1 = a[key]
    //     var val2 = b[key]
    //     return val1 - val2
    //   }
    // }
    const changeFontSizeSubtract = () => {
      if (count.value > 0.47) {
        count.value -= 0.01
        add.value.style.fontSize = count.value + 'rem'
      }
    }
    const routeBack = () => {
      router.back()
    }
    return {
      contentText,
      content,
      voiceText,
      typeName,
      contentList,
      attachedPictures,
      add,
      swiper,
      imgUrl,
      periodical,
      newspaperId,
      newspaper,
      swiperIndex,
      showHeight,
      routeBack,
      changeFontSizeAdd,
      changeFontSizeSubtract
    }
  }
}
</script>

<style lang="scss" scoped>
.content{
  position: relative;
  width: 100%;
  .content__text{
    font-size: .5rem;
    height: 100%;
    text-align: justify;
    overflow-y: auto;
    padding: .4rem .4rem;
    box-sizing: border-box;
    line-height: .8rem;
    &__h3{
      margin: 0;
      text-align: center;
    }
    &__h4{
      margin: 0;
      text-align: center;
    }
    &__p{
      color: #777777;
      font-size: 16px;
      border-bottom: 1px solid #dddddd;
      span{
        margin-right: 6px;
      }
    }
    &__author{
      color: #777777;
      font-size: 16px;
      text-align: center;
    }
    &__img{
      width: 90%;
      margin: 0 auto;
      text-align: center;
      img{
        width: 100%;
        margin-bottom: 10px;
      }
      p{
        font-size: 14px;
      }
    }
    &__content >>> p{
      margin: 0;
    }
  }
  &__item{
    height: 100%;
    overflow-y: auto;
  }
  &__icon{
    position: absolute;
    bottom: 1rem;
    left: 1rem;
    &__wrapper{
      display: inline-block;
      width: 45px;
      height: 45px;
      line-height: 43px;
      border-radius: 50%;
      background-color: #DE1B23;
      text-align: center;
      opacity: 0.5;
      vertical-align: middle;
      &__item{
        color: #ffffff;
        font-size: 0.6rem;
      }
    }
   .left{
     margin-right: 0.5rem;
   }
  }
  &__left{
    width: 1.5rem;
    height: 1.5rem;
    top: 50%;
    left: 0.3rem;
    position: absolute;
    background-image: url('../../../public/img/next.png');
    background-size: 100% 100%;
    transform: rotate(180deg);
    opacity: 0.6;
  }
  &__next{
    width: 1.5rem;
    height: 1.5rem;
    top: 50%;
    right: 0.3rem;
    position: absolute;
    background-image: url('../../../public/img/next.png');
    background-size: 100% 100%;
    opacity: 0.6;
  }

}
</style>
